import { render, staticRenderFns } from "./flowDetail.vue?vue&type=template&id=6b145f72&scoped=true&"
import script from "./flowDetail.vue?vue&type=script&lang=js&"
export * from "./flowDetail.vue?vue&type=script&lang=js&"
import style0 from "./flowDetail.vue?vue&type=style&index=0&id=6b145f72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b145f72",
  null
  
)

export default component.exports